
const protocol = window.location.protocol + '//'
// console.log(protocol)
let urlBack = '';
let urlWeb = '';
if (window.location.hostname === '192.168.1.100' || window.location.hostname === '192.168.167.25' || window.location.hostname === 'www.reghubchina.com') {
    // urlBack = '192.168.167.25:31100'
    // urlWeb = '192.168.167.25:31101'

    urlBack = 'webapi.reghubchina.com'
    urlWeb = 'webapi.reghubchina.com'
}
const api = {
    testUrlBack: 'https://' + urlBack + '/v1/crm',
    testUrlWeb: 'https://' + urlWeb + '/v1/crm',
}

export default api;